import Styled from 'styled-components';

const ReviewsContainer = Styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  margin-left: 25px;
  padding-bottom: 20px;
  width: 100%;
  height: fit-content;
`;

const AuxiliaryTitleWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  background-color: #fafafa;
  padding: 16px 26px;
  width: 100%;
  border-bottom: 1px solid #e9e9e9;
`;

const TextBox = Styled.div`
  width: 100%;
  padding: 20px 20px;
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
  border-bottom: 1px solid #E9E9E9;
`;

const TagContainer = Styled.div`
  display: flex;
  width: 100%;
  padding-left: 26px;
`;

const FilterTagWrapper = Styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 15px 0 0 40px;
`;

const LoadingContainer = Styled(ReviewsContainer)`
  > div {
    > div {
      position: relative;
    }
  }
`;

export default ReviewsContainer;
export { ReviewsContainer, LoadingContainer, AuxiliaryTitleWrapper, TagContainer, FilterTagWrapper, TextBox };
